module.exports = __webpack_public_path__ + "assets/GoldenSection.06869f8b4fb7ffce35f7242e79621262.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/GoldenSection.gmt
// module id = 950
// module chunks = 0